import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { RouteConstants } from "./constants/RouteConstants";
import "./fonts/TeloNeo/TeleNeo.css";
import ConfigPage from "./routes/ConfigPage";
import SlimViewPage from "./routes/SlimViewPage";
import StrikeZonePage from "./routes/StrikeZonePage";

const GlobalStyles = createGlobalStyle`
  html, body {
    font-family: 'TeleNeo', sans-serif !important;
  }
`;

const ADOBE_TRACKING_URL = process.env.ADOBE_TRACKING_URL;

const App: React.FC = () => {
  useEffect(() => {
    if (ADOBE_TRACKING_URL?.length) {
      const head = document.querySelector("head");
      const script = document.createElement("script");

      script.setAttribute("src", ADOBE_TRACKING_URL);
      head.appendChild(script);

      return () => {
        head.removeChild(script);
      };
    }
  }, [ADOBE_TRACKING_URL]);

  return (
    <>
      {/*@ts-ignore*/}
      <GlobalStyles />
      <Routes>
        <Route path={RouteConstants.CONFIG} element={<ConfigPage />} />
        <Route path={RouteConstants.SLIM} element={<SlimViewPage />} />
        <Route path={RouteConstants.STIKE_ZONE} element={<StrikeZonePage />} />
        <Route path={RouteConstants.WILDCARD} element={<StrikeZonePage />} />
      </Routes>
    </>
  );
};

export default App;
